export default __webpack_public_path__ + "img/pbot-verticalapps-logo_dark.9f330913.png";